import { Department } from '../department';

export class Role {
  roleId: number;
  roleDescription: string;
  department: Department;
  orgId: number;
  orgLevel: number;
  roleDashboard: string;
  registrationUrl: string;
  hospitalUserFacilityGroupIds: number[];
}
